import {extendTheme} from '@chakra-ui/react';
import {BottomNavigationStyleConfig} from 'chakra-ui-bottom-navigation';

export const appThemeColors = {
    primary: {
        100: '#e1f5f0',
        300: '#4FD1C5',
        500:'#319795',
        700:'#285E61'
    },
    background: '#ffffff',
    secondary:{
        100:'#ffffff'
    },
    titleColor:'#4A5568',
    subtitleColor: '#718096',
    captionColor: '#718096',
    textColor: '#00000080',
    strongTextColor: '#2D3748',
    borderColor: '#d9d9d9',
    darkButtonColor:'#00000080',
    lightButtonColor: '#ffffff',
    darkOverlay:'#00000030',
    disabledButtonColor: '#B2D6D4',
    iconColor: {
        100: '#eaedee',
        500: '#718096',
    },
    dangerColor: {
        300:'#FED7D7',
        500:'#E53E3E',
        700:'#9B2C2C'
    }
}

export const appTheme = extendTheme({
    colors: appThemeColors,
    components: {
        BottomNavigation: BottomNavigationStyleConfig
    }

})

